module.exports = __webpack_public_path__ + "static/media/JustActMailers_6_V2-01.60c297b7.jpg";